<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button size="icon-only" (click)="dismiss()">
        <ion-icon name="close" color="secondary" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      {{ 'components.cancelationPolicies.title' | transloco }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="ion-padding-horizontal">
    <ion-text >
      <p>
        {{ 'components.cancelationPolicies.description' | transloco }}
      </p>
    </ion-text>
    <app-cancelation-policies
      [service]="service"
      [minimized]="false"
    ></app-cancelation-policies>
  </div>
</ion-content>
